import { Link } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";
import { useState, useRef, useEffect } from "react";

const ShopDropdown = () => {

  const [shopOpen, setShopOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
const dropdownRef = useRef(null);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShopOpen(false);
        setCategoryOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



  return (

     <div ref={dropdownRef} className="relative">
    <div className="relative">

      {/* SHOP BUTTON */}
      <button
        onClick={() => setShopOpen(!shopOpen)}
        className="flex items-center gap-1 hover:text-gray-300 transition"
      >
        Shop

        <FiChevronDown
          className={`transition-transform duration-300 ${
            shopOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* DROPDOWN */}
      {shopOpen && (

        <div className="absolute top-12 left-1/2 -translate-x-1/2 
        bg-white text-black shadow-2xl rounded-xl 
        w-[300px] p-4 z-50">

 {/* Section Label */}
    <p className="text-xs font-semibold text-gray-500 uppercase mb-2">
      Men
    </p>
          {/* BY CATEGORY */}
          <button
            onClick={() => setCategoryOpen(!categoryOpen)}
            className="flex justify-between items-center w-full font-medium text-sm"
          >
            By Category

            <FiChevronDown
              className={`transition-transform duration-300 ${
                categoryOpen ? "rotate-180" : ""
              }`}
            />
          </button>

          {/* CATEGORY LIST */}
          {categoryOpen && (

            <div className="flex flex-col mt-4 gap-3 text-gray-700 text-sm">

              <Link
                to="/products?category=Floral"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="hover:text-black transition"
              >
                Floral
              </Link>

              <Link
                to="/products?category=Nature"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="hover:text-black transition"
              >
               Nature
              </Link>

              <Link
                to="/products?category=Contemporary"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="hover:text-black transition"
              >
               Contemporary
              </Link>
 <Link
                to="/products?category=BeachSide"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="hover:text-black transition"
              >
                BeachSide
              </Link>
               <Link
                to="/products?category=all"
                className="hover:text-black transition"
              >
                View All
              </Link>
            </div>

          )}

        </div>

      )}

    </div>
    </div>
  );
};

export default ShopDropdown;